'use strict';

angular.module('resourceCenterXinhuaModule', ['resCenterXHRouterModule', 'xinhuaQuickPreview']).controller('resCenterXHRelCtrl', [
    '$scope',
    '$state',
    '$stateParams',
    '$filter',
    '$q',
    '$timeout',
    'resCtrModalService',
    'modalDialog',
    'trsspliceString',
    'storageListenerService',
    'xinhuaApiService',
    'localStorageService',
    'trsPrintService',
    'trsHttpService',
    'globleParamsSet',
    'resourceCenterService',
    '$sessionStorage',
    'editNewspaperService',
    function(
        $scope,
        $state,
        $stateParams,
        $filter,
        $q,
        $timeout,
        resCtrModalService,
        modalDialog,
        trsspliceString,
        storageListenerService,
        xinhuaApiService,
        localStorageService,
        trsPrintService,
        trsHttpService,
        globleParamsSet,
        resourceCenterService,
        $sessionStorage,
        editNewspaperService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 页面状态初始化]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.comeFrom = 'source.xinhuadoc';
            $scope.hasCKPicRights = {};
            $scope.operRights = {};
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: localStorageService.get('xinhuaPageNum') || 20, // globleParamsSet.setResourceCenterPageSize,
            };
            $scope.data = {
                items: [],
                pictures: [],
                selectedArray: [],
                selectedDoctype: {},
                operFlags: [],
                flagTotalItems: [],
                printResult: [], // 打印稿件集合
                itemCounts: 0, // 显示的稿件数量
                fromdate: $filter('date')(new Date(), 'yyyy-MM-dd'),
                untildate: $filter('date')(new Date(), 'yyyy-MM-dd'),
                classifies: [], // 分类集合
                selectedClassify: {}, // 选中的分类
                keywords: '',
                originalData: [],
                DomesticOrInternals: [
                    {
                        name: '全部地域',
                        value: '',
                    },
                    {
                        name: '国内',
                        value: 1,
                    },
                    {
                        name: '国外',
                        value: 2,
                    },
                ], // 地域集合
                selectedDomesticOrInternal: {}, // 选中的地域
            };

            $scope.status = {
                currModule: 'xhsg',
                iwoEdit: {
                    1: 'iwonews',
                    2: 'iwoatlas',
                },
                newspaperEdit: {
                    1: 'newspapertext',
                    2: 'newspaperpic',
                },
                websiteEdit: {
                    1: 'websitenews',
                    2: 'websiteatlas',
                },
                unloadover: true, // 图集稿，是否显示加载更多
                isFirstLoad: true, // 首次加载页面（仅全部文字）
                singleGraph: false, // 单图模式：true；多图模式：false
                isCommonList: true, // 是否默认为普通列表展现模式，相对于图片瀑布流模式
                isOpenedPanel: {
                    // 默认展开第一个
                    0: true,
                },
                screenWrapSelected: false, // 默认不展示更多筛选
                labels: [], // 所有标签
                selectedLabels: [], // 当前选中的标签
                multiImgsReady: false, // 多图加载完成
                fcode: $stateParams.fcode,
                ESSearch: false, // 是否从大数据检索数据，只在只看新疆和关键词搜索时为true
                isQuikView: false,
                docType: $state.params.doctype,
                hasphoto: $state.params.doctype === '2',
                isOnlyXJ: false, // 是否只看新疆
                isKeywordSearch: false, // 是否出于关键词搜索模式
            };
            // 图集模式需要使用
            $scope.childStatus = {
                checkString: 'imgurl',
                picString: 'urlS',
                originPicUrl: 'urlM',
                url: 'resourcexhsgbigdatadetail'
            };
            $scope.listParamsForWCM = xinhuaApiService.getDocListParams(); // 如何适应变化？比如默认要当天作为时间筛选
            $scope.listParamsForWCM.OperTimeStart = $scope.data.fromdate;
            $scope.listParamsForWCM.OperTimeEnd = $scope.data.untildate;
            $scope.listParamsForBigdata = xinhuaApiService.getDocListParamsForBigdata();
        }

        /**
         * [clearPageData description]清除列表数据
         * @return {[type]} [description]
         */
        function clearPageData() {
            $scope.data.items = [];
            $scope.data.pictures = [];
            $scope.data.selectedArray = [];
        }

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            listenStorage();
            initcompositeFilter();
            $scope.data.selectedDomesticOrInternal = $scope.data.DomesticOrInternals[0];
            // if ($scope.status.fcode) {
            // if ($state.params.nodename === '通稿新闻线路' || $state.params.nodename === '彩色通稿') {
            // 根据要求只有这两个分类有数据，暂时写死
            getDocClassifys().then(() => {
                requestData();
            });
            // } else {
            //     fakeRequests();
            // }
            getOperRights();
        }

        /**
         * [getOperRights 获取操作权限]
         *
         * @return  {[type]}  [return description]
         */
        function getOperRights() {
            xinhuaApiService.getRightsForXinhua().then((data) => {
                if (data.length) {
                    angular.forEach(data, (item) => {
                        $scope.operRights[item.OPERNAME] = true;
                    });
                }
            });
        }

        /**
         * [initcompositeFilter description]
         *
         * @return  {[type]}  [return description]
         */
        function initcompositeFilter() {
            var userId = $sessionStorage.get('curUserInfo').ID;
            var storage = localStorageService.get('resource.compositeFilter');
            if (storage && storage[userId]) {
                // $scope.status.screenWrapSelected = storage[userId].screenWrapSelected;
                $scope.status.takeDraftStatus = $scope.listParamsForWCM.takeDraftStatus = storage[userId].takeDraftStatus;
                $scope.status.singStatus = $scope.listParamsForWCM.singStatus = storage[userId].singStatus;
                $scope.status.products = $scope.listParamsForWCM.products = storage[userId].products;
            }
            if ($scope.status.takeDraftStatus || $scope.status.singStatus || $scope.status.products !== '[]') {
                $scope.status.screenWrapSelected = true;
            }
        }

        /**
         * [fakeRequestsForBigdata description] 因为暂无数据效果不好，发送一个假请求--大数据检索用
         * @return  {[type]}  [return description]
         */
        function fakeRequestsForBigdata() {
            $scope.data.fromdate = new Date().getDate() + 1;
            $scope.data.untildate = new Date().getDate() + 1;
            requestData();
        }

        /**
         * [fakeRequests description] 因为暂无数据效果不好，发送一个假请求
         * @return  {[type]}  [return description]
         */
        function fakeRequests(){
            if ($scope.status.ESSearch) {
                fakeRequestsForBigdata();
            } else {
                $scope.listParamsForWCM.OperTimeStart = new Date().getDate() + 1;
                $scope.listParamsForWCM.OperTimeEnd = new Date().getDate() + 1;
                requestData();
            }
        }

        /**
         * [getDocClassifys description] 获取分类
         * @return  {[type]}  [return description]
         */
        function getDocClassifys() {
            var defer = $q.defer();
            var params = xinhuaApiService.getDocClassifyParams();
            xinhuaApiService.getDocClassifys(params).then((data) => {
                $scope.data.classifies = globleParamsSet.dealDropDownData(data, 'DOCCLASSIFYNAME', 'DOCCLASSIFYID');
                $scope.data.classifies.unshift({
                    // 默认添加全部分类
                    name: '全部分类',
                    value: '',
                });
                $scope.data.selectedClassify = angular.copy(data)[0];
                $scope.listParamsForWCM.DocClassifyId = $scope.data.selectedClassify.value;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [requestData description]请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            let params = dealListParams();
            $scope.loadingPromise = xinhuaApiService.getDocList(params).then(function(data) {
                $scope.data.originalData = data;
                data = xinhuaApiService.dealListData(data);
                $scope.page.PAGECOUNT = data.page.PAGECOUNT;
                $scope.page.ITEMCOUNT = data.page.ITEMCOUNT;
                if ($scope.status.docType === '2') {
                    dealAltasImg(data.datas);
                } else {
                    getFlagList(data.datas);
                }
            });
        }

        /**
         * [getImgLogos description] 获取图示
         * @param   {[Array]}  listData  [listData description] 稿件集合
         * @return  {[type]}             [return description]
         */
        function getImgLogos(listData) {
            if (!$scope.hasphoto){
                let params = xinhuaApiService.getImgLogosParams();
                let pictureItemIds = [];
                listData.forEach(function(item) {
                    pictureItemIds.push(item.id); // 现在文字跟图片完全分开不需要判断
                });
                if (pictureItemIds.length) {
                    params.XHSGSourceIds = pictureItemIds.join(',');
                    $scope.loadingPromise = xinhuaApiService.getImgLogos(params).then(function(data) {
                        $scope.data.pictures = data;
                        showImgLogos(listData);
                    });
                } else {
                    // resetListData(listData);
                }
            } else {
                dealAltasImg(listData);
            }
        }

        /**
         * [dealAltasImg 处理图集稿的图片]
         *
         * @param   {[type]}  listData  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealAltasImg(listData) {
            angular.forEach(listData, function (item, index) {
                if (item.imgurl && item.imgurl.length) {
                    angular.forEach(item.imgurl, function(subitem, subindex){
                        listData[index].imgurl[subindex].urlM = subitem.PICSLOGO;
                        listData[index].imgurl[subindex].urlS = subitem.PICSLOGO;
                    });
                }
            });
            getFlagList(listData);
        }

        /**
         * [getFlagList description] 获取操作记录
         * @param   {[Array]}  listData  [listData description] 列表集合
         * @return  {[type]}             [return description]
         */
        function getFlagList(listData) {
            let params = xinhuaApiService.getFlagParams();
            params.XHSGSourceIds = trsspliceString.spliceString(listData, 'id', ',');
            $scope.loadingPromise = xinhuaApiService.getFlag(params).then(function(data) {
                listData.forEach(function(item, index) {
                    data.forEach(function(subitem) {
                        if (subitem.XHSGID === item.id) {
                            listData[index].flags = subitem;
                        }
                    });
                });
                // 判断是否是图集稿件
                if ($scope.status.hasphoto) {
                    $scope.data.itemCounts = 0;
                    $scope.status.multiImgsReady = true;
                } else {
                    $scope.status.multiImgsReady = false;
                    // findReprintCounts();
                }
                resetListData(listData);
                setPageTurningData();
            });
        }

        /**
         * [resetListData 重置列表数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function resetListData(data){
            $scope.data.items = data;
            $scope.data.selectedArray = [];
        }

        /**
         * [setPageTurningData 设置详情页上下篇切换的ID集合缓存]
         *
         * @return  {[type]}  [return description]
         */
        function setPageTurningData() {
            localStorageService.set('xhDetailTurning', $scope.data.items);
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param   {[type]}  item       [item description]
         * @param   {[type]}  flagIndex  [flagIndex description]
         * @return  {[type]}             [return description]
         */
        $scope.showOperFlag = function(item, flagIndex) {
            if (item.flags) {
                return item.flags.OPERFLAG.substr(flagIndex, 1) === '1';
            } else {
                return false;
            }
        };

        /**
        * [viewInfo description]取签见撤重 点击弹出
        *
        * @param   {[type]}  item      [item description]
        * @param   {[type]}  bool      [bool description]
        * @param   {[type]}  selected  [selected description]
        *
        * @return  {[type]}            [return description]
        */
        $scope.viewInfo = function(item, bool, selected) {
            let params = xinhuaApiService.getFlagListParams();
            var operFlags = item.flags.OPERFLAG;
            params.XHSGSourceId = item.id;
            $scope.loadingPromise = xinhuaApiService.getFlagList(params).then(function(data) {
                resCtrModalService.operRecordsModal(data, operFlags, selected);
            });
        };

        /**
         * [queryByDropdown description] test筛选条件触发后请求数据(时间下拉)
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */

        $scope.queryByDropdown = function(key, value) {
            clearPageData();
            $scope.page.CURRPAGE = 1;
            if (key === 'OperTime') {
                $scope.listParamsForWCM.OperTimeStart = $scope.data.fromdate;
                $scope.listParamsForWCM.OperTimeEnd = $scope.data.untildate;
            } else {
                $scope.listParamsForWCM[key] = value; 
            }
            // if ($state.params.nodename === '通稿新闻线路' || $state.params.nodename === '彩色通稿') { // 根据要求只有这两个分类有数据，暂时写死
            requestData();
            // } else {
            //     fakeRequests();
            // }
        };

        /**
         * [showImgLogos description] 显示缩略图
         * @param   {[Array]}  listData  [listData description]
         * @return  {[type]}             [return description]
         */
        function showImgLogos(listData) {
            listData.forEach(function(item, index) {
                if ($scope.data.pictures && $scope.data.pictures[item.id]) {
                    listData[index].imgurl = $scope.data.pictures[item.id];
                    listData[index].imgurl.forEach(function(subitem, subindex) {
                        listData[index].imgurl[subindex].urlM = subitem.PICSLOGO;
                        listData[index].imgurl[subindex].urlS = subitem.PICSLOGO;
                    });
                }
            });
            getFlagList(listData);
        }

        /**
         * [dealListParams 列表参数处理]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParams(){
            let params;
            $scope.status.ESSearch = $scope.status.isOnlyXJ || $scope.status.isKeywordSearch;
            if ($scope.status.ESSearch) {
                params = dealListParamForBigData();
            } else {
                params = dealListParamForWCM();
            }
            return params;
        }

        /**
         * [dealListParamForWCM 从采编获取新华社稿数据]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParamForWCM() {
            var params = angular.extend({}, $scope.listParamsForWCM, $scope.page);
            if ($scope.status.takeDraftStatus !== 2) {
                params.singStatus = $scope.status.singStatus;
                params.products = $scope.status.products;
            } else {
                delete params.singStatus;
                delete params.products;
            }
            delete params.PAGECOUNT;
            delete params.ITEMCOUNT;
            return params;
        }

        /**
         * [dealListParamForBigData 处理海贝检索参数]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParamForBigData(){
            let date = '';
            if ($scope.data.fromdate !== '') {
                date += $scope.data.fromdate;
            }
            if ($scope.data.untildate !== '') {
                date += ',' + $scope.data.untildate;
            }
            let searchParams = {
                PAGESIZE: $scope.page.PAGESIZE,
                PAGEINDEX: $scope.page.CURRPAGE,
                searchFields: [
                    {
                        searchField: 'DocClassifyId',
                        keywords: $scope.data.selectedClassify.value || '',
                    },
                    {
                        searchField: 'LineClassifyId',
                        keywords: $state.params.fcode || '',
                    },
                    {
                        searchField: 'docType',
                        keywords: $state.params.doctype || '',
                    },
                    {
                        searchField: 'timeType',
                        keywords: date,
                    },
                    {
                        searchField: 'isOnlyXinjiang',
                        keywords: $scope.status.isOnlyXJ,
                    },
                    {
                        searchField: '_sort',
                        keywords: 'time',
                    },
                    {
                        searchField: '',
                        keywords: $scope.data.keywords,
                    },
                    {
                        searchField: 'DOMESTICOCINTERNAL',
                        keywords: $scope.data.selectedDomesticOrInternal.value || '',
                    }
                ],
            };
            var bigDataParams = angular.extend({}, $scope.listParamsForBigdata, {
                searchParams: JSON.stringify(searchParams),
            });
            return bigDataParams;
        }

        /**
         * [pageChanged description]分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData();
        };

        /**
         * [selectAll description] 全选
         * @return  {[type]}  [return description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description] 单选
         * @param   {[object]}  item  [item description] 稿件对象
         * @return  {[type]}          [return description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [selectedBranch 获得已选稿件的id集合]
         *
         * @return  {[type]}  [return description]
         */
        function selectedBranch() {
            var branchObj = {
                ids: [],
            };
            angular.forEach($scope.data.selectedArray, function(value, key) {
                branchObj.ids.push(value.id);
            });
            return branchObj;
        }

        /**
         * [openTakeDraftModal description]取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var branchObj = selectedBranch();
            openWCMTakeDraftModal(branchObj.ids);
        };

        /**
         * [openWCMTakeDraftModal 采编取稿]
         *
         * @param   {[type]}  ID  [ID description]
         *
         * @return  {[type]}      [return description]
         */
        function openWCMTakeDraftModal(ID) {
            if (!determineSelected() || ID.length === 0) {
                return;
            }
            var params = xinhuaApiService.getFetchParams();
            params.XHSGSourceIds = ID.join(',');
            var isOnlyOne = !($scope.data.selectedArray.length > 1);
            var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
            modalInstance.result.then(
                function() {
                    clearPageData();
                    requestData();
                },
                function() {}
            );
        }

        /**
         * [determineSelected 判断稿件是否选中]
         *
         * @return  {[type]}  [return description]
         */
        function determineSelected() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return false;
            } else {
                return true;
            }
        }

        /**
         * [searchWithKeyword 关键词搜索]
         * @param   {[type]}  ev    [key description]
         * @return  {[type]}         [return description]
         */
        $scope.searchWithKeyword = function(ev) {
            if ($scope.data.keywords !== '') {
                $scope.status.isKeywordSearch = true;
            } else {
                $scope.status.isKeywordSearch = false;
            }
            
            let spaceKeyCode = 13;
            if ((ev && ev.keyCode === spaceKeyCode) || !ev) { 
                $scope.page.CURRPAGE = 1;
                // $scope.listParamsForWCM.title = $scope.data.keywords;
                clearPageData();
                requestData();
            }
        };

        /**
         * [dealwithTime description]处理返回时间
         * @param  {[type]} pubTime [description]
         * @return {[type]}         [description]
         */
        $scope.dealwithTime = function(pubTime) {
            if (pubTime !== undefined) {
                return pubTime.replace(/\//g, '-');
            }
            return '';
        };

        /**
         * [quickPreview description] 快速预览模式
         * @return {[type]} [description]
         */
        $scope.quickPreview = function() {
            $scope.$root.selectedInfo = {}; // 定义当前页面（选中）信息
            $scope.$root.selectedInfo.quickPreviewPageNum = $scope.page.CURRPAGE; // 当前页，用于展示普通列表
            // 已选时间
            if (!!$scope.data.fromdate) {
                $scope.$root.selectedInfo.fromdate = $scope.data.fromdate;
                $scope.$root.selectedInfo.untildate = $scope.data.untildate;
            }
            $state.go('front.resourcectrl.xinhua.quickpreview', $stateParams); // 链接跳转
        };

        /**
         * [printBtn description] 稿件打印功能
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function() {
            angular.forEach($scope.data.selectedArray, function(value, key) {
                getDetail(value).then(function(data) {
                    $scope.data.printResult.push(data);
                    if ($scope.data.printResult.length === $scope.data.selectedArray.length) {
                        trsPrintService.trsPrintXhsg($scope.data.printResult);
                        $scope.data.printResult = [];
                    }
                });
            });
        };

        /**
         * [getDetail description] 获取详情为了打印 （存在有获取详情的公共方法，因为打印模板需要大写字段，公共方法使用小写字段，暂时不使用公共方法）
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function getDetail(item) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_xhsgsource',
                methodname: $scope.status.hasphoto ? 'getPicXHSG' : 'getNewsXHSG',
                XHSGSourceId: item.id,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [collect description] 稿件收藏
         * @return  {[type]}  [return description]
         */
        $scope.collect = function() {
            modalDialog.confirmModal('收藏', '是否收藏所选稿件?', function() {
                var params = {
                    methodname: 'collects',
                };
                trsHttpService
                    .httpServer(
                        trsHttpService.getWCMRootUrl(),
                        angular.extend({}, params, xinhuaApiService.getOperParams($scope.data.selectedArray)),
                        'post'
                    )
                    .then(function(data) {
                        modalDialog.alertType('收藏成功', '', 'success', false);
                        $scope.data.selectedArray = [];
                    });
            });
        };

        /**
         * [export description] 稿件导出
         * @return  {[type]}  [return description]
         */
        $scope.export = function() {
            var params = {
                methodname: 'exportWordFile',
            };
            $scope.loadingPromise = globleParamsSet
                .exportDraft(angular.extend({}, params, xinhuaApiService.getOperParams($scope.data.selectedArray)))
                .then(() => {
                    $scope.data.selectedArray = [];
                });
        };

        /**
         * [creationAxis description] 添加个人素材
         * @return  {[type]}  [return description]
         */
        $scope.creationAxis = function() {
            modalDialog.confirmModal('添加个人素材成功', '是否将所选稿件添加到个人素材?', function() {
                var params = {
                    methodname: 'creations',
                    channelName: $scope.data.selectedClassify.name,
                };
                trsHttpService
                    .httpServer(
                        trsHttpService.getWCMRootUrl(),
                        angular.extend({}, params, xinhuaApiService.getOperParams($scope.data.selectedArray)),
                        'post'
                    )
                    .then(function(data) {
                        modalDialog.alertType('添加个人素材成功', '', 'success', false);
                        $scope.data.selectedArray = [];
                    });
            });
        };

        /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
        $scope.singleGraphMode = function() {
            $scope.page.CURRPAGE = 1;
            clearPageData();
            $scope.status.singleGraph = !$scope.status.singleGraph;
            requestData();
        };

        /**
         * [loadMore description] 图集-加载更多图片
         * @return {[type]} [description]
         */
        $scope.imgLoadMore = function() {
            if ($scope.page.CURRPAGE < $scope.page.PAGECOUNT) {
                $scope.page.CURRPAGE++;
                requestData();
            }
        };

        /**
         * [scrollShowMore description] 滚动加载更多
         * @return {[type]} [description]
         */
        $scope.scrollShowMore = function() {
            if ($scope.status.hasphoto) {
                $scope.imgLoadMore();
            }
        };

        /**
         * [changePicModelType description] 切换视图
         *
         * @return  {[type]}  [return description]
         */
        $scope.changePicModelType = function() {
            // $scope.page.CURRPAGE = 1;
            clearPageData();
            $scope.status.hasphoto = !$scope.status.hasphoto;
            requestData();
        };

        /**
         * [onlyXj 只看新疆操作接口]
         *
         * @return  {[type]}  [return description]
         */
        $scope.onlyXj = function() {
            $scope.status.isOnlyXJ = !$scope.status.isOnlyXJ;
            onlyXj();
        };

        /**
         * [onlyXj 只看新疆实现]
         *
         * @return  {[type]}  [return description]
         */
        function onlyXj() {
            $scope.page.CURRPAGE = 1;
            requestData();
        }

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            savePageNumToStorage();
            requestData();
        };

        /**
         * [savePageNumToStorage 新华社稿分页条数持久化]
         *
         * @return  {[type]}  [return description]
         */
        function savePageNumToStorage() {
            localStorageService.set('xinhuaPageNum', $scope.page.PAGESIZE);
        }

        /**
         * [goToDetail description] 图集模式细览跳转
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function(item){
            var params = {
                docid: item.id, 
                type: item.doctype
            };
            var url = $state.href('resourcexhsgbigdatadetail', params);
            window.open(url, '_blank');
        };

        /**
         * [showAtlasCarouselWindow 显示图集预览弹窗]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.showAtlasCarouselWindow = function (item) {
            let options = {
                item: item,
            };
            resourceCenterService.showAtlasCarouselWindow(options);
        };

        /**
         * [getTakeDraftParams 获取取稿参数]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.getTakeDraftParams = function (item) {
            let takeDraftParams = xinhuaApiService.getFetchParams();
            takeDraftParams.XHSGSourceIds = item.id;
            item.DOCTYPE = item.doctypeId;
            return takeDraftParams;
        };

        $scope.getGoDetailParams = function (item) {
            let goDetailPareams = {};
            goDetailPareams = {
                docid: item.id,
                type: item.doctype,
                routerName: 'resourcexhsgbigdatadetail',
            };
            return goDetailPareams;
        };

        /**
         * [getAtlasCarouselWindowOptions 获取图集预览弹出窗口的相关配置项]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.getAtlasCarouselWindowOptions = function (item) {
            let takeDraftParams = $scope.getTakeDraftParams(item);
            let goDetailPareams = $scope.getGoDetailParams(item);
            let options = {
                item: item, // 要预览的图集对象
                imgListKey: 'imgurl', // 图集中图片列表的键名
                bigPicKey: 'urlM', // 大图的键名
                smallPicKey: 'urlS', // 小图的键名
                infoKey: 'summary', // 每张图的说明文字的键名
                takeDraftParams: takeDraftParams, // 取稿参数
                goDetailPareams: goDetailPareams, // 跳转详情页的参数
            };
            return options;
        };
        $scope.compositeFilter = {};
        $scope.screenWrap = function() { // 收起筛选和展开筛选的方法
            $scope.status.screenWrapSelected = !$scope.status.screenWrapSelected;
            // $scope.compositeFilter.saveStorage('screenWrapSelected', $scope.status.screenWrapSelected);
        };

        // 直接签发
        $scope.directSign = function() {
            editNewspaperService.useSignZP(
                $scope.data.selectedArray, 
                () => {
                    requestData();
                },
                '',
                '',
                {
                    isFromResourceCenter: true,
                    methodname: 'fetchAndPublishXHSG',
                    sourceName: '资源中心-新华社稿库'
                }
            );
        };
    },
]);
